export { ErrorPage } from './page.component';
